import class1 from "../../images/classes_1.png";
import class2 from "../../images/classes_2.png";
import class3 from "../../images/classes_3.png";
import class4 from "../../images/classes_4.png";
import class5 from "../../images/classes_5.png";
import class6 from "../../images/classes_6.png";
import class7 from "../../images/yoga_1.png";
import class8 from "../../images/yoga_2.png";
import class9 from "../../images/yoga_3.png";
import class10 from "../../images/yoga_4.png";
import class11 from "../../images/yoga_5.png";
import class12 from "../../images/yoga_6.png";
import class13 from "../../images/yoga_7.png";
import class14 from "../../images/yoga_8.png";
import class15 from "../../images/yoga_9.png";
import classList1 from "../../images/class_list_6.png"
import classList2 from "../../images/class_list_2.png"
import classList3 from "../../images/class_list_3.png"
import classList4 from "../../images/class_list_4.png"
import classList5 from "../../images/class_list_5.png"
import classList6 from "../../images/class_list_6.png"
import classList7 from "../../images/class_list_7.png"
import classList8 from "../../images/class_list_8.png"
import classList9 from "../../images/class_list_9.png"

export const ServiceData = [
  {
    id: 1,
    name: "Yoga To Realize And Love Yourself",
    img: class1,
    img2 : classList1,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 2,
    name: "Free Style Yoga For Stress Relieves",
    img: class2,
    img2 : classList2,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 3,
    name: "Yoga Poses For Inner Acceptance",
    img: class3,
    img2 : classList3,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 4,
    name: "Flow Yoga To Energize Our Body",
    img: class4,
    img2 : classList4,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 5,
    name: "Welcome To The World Of Yoga",
    img: class5,
    img2 : classList5,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 6,
    name: "Yoga For Better And Healthy Living",
    img: class6,
    img2 : classList6,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 7,
    name: "Flow Yoga To Energize Our Body",
    img: class7,
    img2 : classList7,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 8,
    name: "Welcome To The World Of Yoga",
    img: class8,
    img2 : classList8,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 9,
    name: "Free Style Yoga For Stress Relieves",
    img: class9,
    img2 : classList9,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 10,
    name: "Yoga For Better And Healthy Living",
    img: class10,
    img2 : classList1,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 11,
    name: "Yoga Poses For Inner Acceptance",
    img: class11,
    img2 : classList2,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 12,
    name: "Flow Yoga To Energize Our Body",
    img: class12,
    img2 : classList4,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 13,
    name: "Welcome To The World Of Yoga",
    img: class13,
    img2 : classList6,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 14,
    name: "Yoga For Better And Healthy Living",
    img: class14,
    img2 : classList8,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
  {
    id: 15,
    name: "Flow Yoga To Energize Our Body",
    img: class15,
    img2 : classList9,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ more",
    cls: "5 Classes",
    day: "15 Days",
    status: "Beginner",
  },
];
